import React, { useCallback, useState } from 'react';
import {
  Card, Container, Table, TableBody, TableCell, TableContainer,
  TablePagination, TableRow,
} from '@material-ui/core';

import { observer } from 'mobx-react-lite';
import {
  CommonListHead, CommonListToolbar, HeaderBreadcrumbs, Page, Scrollbar, SearchNotFound,
} from '../../../components';
import { CONTACT_MESSAGES_HEAD_LIST } from './constants';
import { useStore, useSearch } from '../../../hooks';
import { PATH_DASHBOARD } from '../../../app';
import { useSorting } from '../../../hooks/useSorting';
import { BecomePartnerItem } from './BecomePartnerItem';

export const BecomePartnerList: React.FC = observer(() => {
  const {
    becomePartner: {
      items, meta, fetchBecomePartners,
    },
  } = useStore();

  const {
    sort, order, orderBy, onClickSorting,
  } = useSorting();

  const { searchValue, setSearchValue, debouncedSearchValue } = useSearch();

  const [page, setPage] = useState<number>(0);

  const handlePageChange = useCallback(
    (_: unknown, newPage: number): void => {
      setPage(newPage);
    },
    [],
  );

  React.useEffect(() => {
    fetchBecomePartners({ sort, page: page + 1, contactPersonName: debouncedSearchValue });
  }, [sort, page, debouncedSearchValue]);

  return (
    <Page title="Become a Partner">
      <Container maxWidth={false}>
        <HeaderBreadcrumbs
          heading="Become a Partner"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Become A Partner' },
          ]}
        />
        <Card>
          <CommonListToolbar searchValue={searchValue} onSearch={setSearchValue} placeholder="Search by name..." />
          <TableContainer>
            <Scrollbar>
              <Table>
                <CommonListHead
                  headListData={CONTACT_MESSAGES_HEAD_LIST}
                  order={order}
                  orderBy={orderBy}
                  onClick={onClickSorting}
                />
                <TableBody>
                  {items.length ? items.map((item) => (
                    <BecomePartnerItem
                      key={`become-partner-${item.id}`}
                      data={item}
                    />
                  )) : (
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={meta.totalItems}
            rowsPerPage={meta.itemsPerPage}
            page={page}
            onPageChange={handlePageChange}
          />
        </Card>
      </Container>
    </Page>
  );
});
